import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
// import store from '../store'
import router from '../router'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  timeout: 30000, // 请求超时时间
  headers: { 'AJAX-PF-CODE': 'to_business' } // 表明该请求来自于哪一个系统
})

// request拦截器
service.interceptors.request.use(
  config => {
    config.headers['ZY_TRANSID'] = Math.random()
      .toString(36)
      .substr(2)
    let token = localStorage.getItem('token')
    if (token) {
      config.headers['USER_TOKEN_HEAD'] = token
    }
    if (config.method === 'post') {
      config.headers['Content-Type'] = 'application/json'
      if (config.data) {
        config.data = JSON.stringify(config.data)
      }
    }
    return config
  },
  error => {
    // Do something with request error
    return Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  response => {
    // 1正常， 30402第三方登录未注册, 9201001未登录, 9201002没有操作权限
    let code = response.data.code

    // 只判断token是否有效，不去登录
    if (response.config.notLogin) {
      if (code === 1) {
        return response.data
      } else {
        return Promise.reject(response.data)
      }
    }

    if (code === 1 || code === 30402) {
      return response.data
    } else if (code === 9201001) {
      MessageBox({
        title: '提示',
        message: response.data.message,
        type: 'error',
        callback: (action, instance) => {
          localStorage.clear()
          router.push({ path: '/', query: { logout: +new Date() } })
        }
      })
      return Promise.reject(response.data)
    } else {
      Message({
        message: response.data.message,
        type: 'error'
      })
      return Promise.reject(response.data)
    }
  },
  error => {
    Message({
      message: '接口返回数据错误',
      type: 'error'
    })
    return Promise.reject(error)
  }
)

export default service
